import React, { Component } from "react";
import RestServiceStatic from "../services/rest.service"
import Loading from "./Loading";

export default class RedirectFediverse extends Component {

  constructor(props) {

    super(props);

    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const code = params.get('code');

    let fediverseInstance = localStorage.getItem(this.props.type + 'Instance');

    if (code && code.trim() !== "" && fediverseInstance !== "") {
      RestServiceStatic.fediverseSignIn(code, fediverseInstance, this.props.type);
    }
  }

  render() {

    return (
        <Loading msg={this.props.msg}/>
    );
  }


}
